var P = { exports: {} }, t = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var F;
function se() {
  if (F) return t;
  F = 1;
  var S = Symbol.for("react.element"), p = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), u = Symbol.for("react.context"), R = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), _;
  _ = Symbol.for("react.module.reference");
  function n(e) {
    if (typeof e == "object" && e !== null) {
      var y = e.$$typeof;
      switch (y) {
        case S:
          switch (e = e.type, e) {
            case a:
            case c:
            case i:
            case m:
            case d:
              return e;
            default:
              switch (e = e && e.$$typeof, e) {
                case R:
                case u:
                case l:
                case v:
                case E:
                case f:
                  return e;
                default:
                  return y;
              }
          }
        case p:
          return y;
      }
    }
  }
  return t.ContextConsumer = u, t.ContextProvider = f, t.Element = S, t.ForwardRef = l, t.Fragment = a, t.Lazy = v, t.Memo = E, t.Portal = p, t.Profiler = c, t.StrictMode = i, t.Suspense = m, t.SuspenseList = d, t.isAsyncMode = function() {
    return !1;
  }, t.isConcurrentMode = function() {
    return !1;
  }, t.isContextConsumer = function(e) {
    return n(e) === u;
  }, t.isContextProvider = function(e) {
    return n(e) === f;
  }, t.isElement = function(e) {
    return typeof e == "object" && e !== null && e.$$typeof === S;
  }, t.isForwardRef = function(e) {
    return n(e) === l;
  }, t.isFragment = function(e) {
    return n(e) === a;
  }, t.isLazy = function(e) {
    return n(e) === v;
  }, t.isMemo = function(e) {
    return n(e) === E;
  }, t.isPortal = function(e) {
    return n(e) === p;
  }, t.isProfiler = function(e) {
    return n(e) === c;
  }, t.isStrictMode = function(e) {
    return n(e) === i;
  }, t.isSuspense = function(e) {
    return n(e) === m;
  }, t.isSuspenseList = function(e) {
    return n(e) === d;
  }, t.isValidElementType = function(e) {
    return typeof e == "string" || typeof e == "function" || e === a || e === c || e === i || e === m || e === d || e === T || typeof e == "object" && e !== null && (e.$$typeof === v || e.$$typeof === E || e.$$typeof === f || e.$$typeof === u || e.$$typeof === l || e.$$typeof === _ || e.getModuleId !== void 0);
  }, t.typeOf = n, t;
}
var o = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var I;
function ae() {
  return I || (I = 1, process.env.NODE_ENV !== "production" && function() {
    var S = Symbol.for("react.element"), p = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), u = Symbol.for("react.context"), R = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), _ = !1, n = !1, e = !1, y = !1, L = !1, M;
    M = Symbol.for("react.module.reference");
    function w(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === a || r === c || L || r === i || r === m || r === d || y || r === T || _ || n || e || typeof r == "object" && r !== null && (r.$$typeof === v || r.$$typeof === E || r.$$typeof === f || r.$$typeof === u || r.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === M || r.getModuleId !== void 0));
    }
    function s(r) {
      if (typeof r == "object" && r !== null) {
        var C = r.$$typeof;
        switch (C) {
          case S:
            var b = r.type;
            switch (b) {
              case a:
              case c:
              case i:
              case m:
              case d:
                return b;
              default:
                var x = b && b.$$typeof;
                switch (x) {
                  case R:
                  case u:
                  case l:
                  case v:
                  case E:
                  case f:
                    return x;
                  default:
                    return C;
                }
            }
          case p:
            return C;
        }
      }
    }
    var g = u, h = f, O = S, Y = l, N = a, D = v, z = E, V = p, q = c, j = i, U = m, W = d, $ = !1, A = !1;
    function X(r) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function k(r) {
      return A || (A = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function G(r) {
      return s(r) === u;
    }
    function H(r) {
      return s(r) === f;
    }
    function Z(r) {
      return typeof r == "object" && r !== null && r.$$typeof === S;
    }
    function B(r) {
      return s(r) === l;
    }
    function J(r) {
      return s(r) === a;
    }
    function K(r) {
      return s(r) === v;
    }
    function Q(r) {
      return s(r) === E;
    }
    function ee(r) {
      return s(r) === p;
    }
    function re(r) {
      return s(r) === c;
    }
    function te(r) {
      return s(r) === i;
    }
    function oe(r) {
      return s(r) === m;
    }
    function ne(r) {
      return s(r) === d;
    }
    o.ContextConsumer = g, o.ContextProvider = h, o.Element = O, o.ForwardRef = Y, o.Fragment = N, o.Lazy = D, o.Memo = z, o.Portal = V, o.Profiler = q, o.StrictMode = j, o.Suspense = U, o.SuspenseList = W, o.isAsyncMode = X, o.isConcurrentMode = k, o.isContextConsumer = G, o.isContextProvider = H, o.isElement = Z, o.isForwardRef = B, o.isFragment = J, o.isLazy = K, o.isMemo = Q, o.isPortal = ee, o.isProfiler = re, o.isStrictMode = te, o.isSuspense = oe, o.isSuspenseList = ne, o.isValidElementType = w, o.typeOf = s;
  }()), o;
}
process.env.NODE_ENV === "production" ? P.exports = se() : P.exports = ae();
var ie = P.exports;
export {
  ie as r
};
